import ENDPOINTS from '@/config/http/endpoints'
import { parseResponse } from '@/config/http/http.helpers'
import { ApiFetchBankInformationSchema } from '@/ducks/billing/billing.schema'
import {
  ApiFetchBankInformation,
  IGetBillingCycleDetailsResponse,
  IGetBillingCyclesResponse
} from '@/ducks/billing/billing.types'
import { rootApi } from '@/ducks/root.api'

export const billingApi = rootApi.injectEndpoints({
  endpoints: build => {
    return {
      fetchBillingCycles: build.query<
        IGetBillingCyclesResponse,
        { storeId: string }
      >({
        query: ({ storeId }) => ({
          method: 'GET',
          url: ENDPOINTS.GET_BILLING_CYCLES(storeId)
        })
      }),
      fetchBillingCycleDetails: build.query<
        IGetBillingCycleDetailsResponse,
        { storeId: string; cycleId: string }
      >({
        query: ({ storeId, cycleId }) => ({
          method: 'GET',
          url: ENDPOINTS.GET_BILLING_CYCLE_DETAILS(storeId, cycleId)
        })
      }),
      fetchBankInformation: build.query<
        ApiFetchBankInformation,
        { storeId: string }
      >({
        query: ({ storeId }) => ({
          method: 'GET',
          url: ENDPOINTS.GET_BANK_INFORMATION(storeId)
        }),
        transformResponse: (response: ApiFetchBankInformation) => {
          return parseResponse(response, ApiFetchBankInformationSchema)
        }
      })
    }
  }
})

const {
  useLazyFetchBillingCyclesQuery,
  useLazyFetchBillingCycleDetailsQuery,
  useFetchBankInformationQuery
} = billingApi

export {
  useFetchBankInformationQuery,
  useLazyFetchBillingCycleDetailsQuery,
  useLazyFetchBillingCyclesQuery
}
